module.exports = __webpack_public_path__ + "img/login_image_guide_en@2x.83f319cd.png";